import React, { useEffect, useRef, useState } from "react";
import styles from "./Home.module.scss";
import { Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
interface MainDirections {
  name: string;
  image: string;
  alt: string;
}
interface AnimatedBlock {
  data: MainDirections;
  handleGoTo: () => void;
}

const AnimatedBlock = ({ data, handleGoTo }: AnimatedBlock) => {
  const { t } = useTranslation();
  const blockRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (blockRef.current) {
        const blockTop = blockRef.current.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (blockTop < windowHeight * 0.75 && blockTop > -windowHeight * 0.25) {
          setIsVisible(true);
        } else setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    blockRef.current && blockRef.current.classList.add("active");

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Col
      ref={blockRef}
      className={isVisible ? styles.colDirectionActive : styles.colDirection}
      xs={{ span: 12 }}
      lg={{ span: 6 }}
      onClick={() => handleGoTo()}
    >
      <img src={data.image} className={styles.imageDirections} alt={data.alt} />
      <div className={styles.directionName}>{data.name}</div>
      <div className={styles.seeProjectsText} onClick={() => handleGoTo()}>
        {t("buttons.projects")}{" "}
        <FontAwesomeIcon icon={faArrowRight} color="#5c5c5c" />
      </div>
    </Col>
  );
};

export default AnimatedBlock;
